import React from 'react'
import { DatePicker } from 'antd/es'
import { Moment } from 'moment/moment'
import styled from 'styled-components'
import type { RangePickerProps as BaseRangePickerProps } from 'antd/es/date-picker/generatePicker'

export type DateRangeProps = {
  type: 'week' | 'month' | 'year'
  onChange: (from: Moment | null, to: Moment | null) => void
} & BaseRangePickerProps<Moment>

type RangeValue = [Moment | null, Moment | null] | null

const { RangePicker } = DatePicker

const Container = styled.div`
  display: flex;
  justify-content: center;
`

export function DateRange({ type, onChange, ...props }: DateRangeProps) {
  return (
    <Container>
      <RangePicker
        picker={type}
        onChange={(range: RangeValue) => {
          if (range) {
            onChange(range[0], range[1])
          }
        }}
        {...props}
      />
    </Container>
  )
}
